import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faChalkboardUser,
  faChartLine,
  faClipboardList,
  faStopwatch,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mantine/core";
import React from "react";
import { Role } from "../../../../types/persons/Role";

export type RoleIconConfig = {
  role: Role;
  label: string;
  icon: IconDefinition;
};

export const roleIconConfig: RoleIconConfig[] = [
  { role: Role.referee, label: "Referee", icon: faStopwatch },
  { role: Role.scoretable, label: "Scoretable", icon: faClipboardList },
  { role: Role.supervisor, label: "Supervisor", icon: faUserShield },
  { role: Role.refereeCoach, label: "Referee Coach", icon: faChalkboardUser },
  { role: Role.administrative, label: "Administrative", icon: faBriefcase },
  { role: Role.statistician, label: "Statistician", icon: faChartLine },
];

export const roleIconColors = {
  active: "var(--color-text-primary)",
  inactive: "var(--color-text-disabled)",
};

export const RoleIconDisplay: React.FC<{ value: Role }> = ({ value }) => (
  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
    {roleIconConfig.map(({ role, icon, label }) => {
      const active = Role.hasRole(value, role);
      return (
        <Tooltip key={role} label={label} withArrow withinPortal>
          <FontAwesomeIcon
            icon={icon}
            style={{
              color: active ? roleIconColors.active : roleIconColors.inactive,
              opacity: active ? 1 : 0.6,
              fontSize: "1rem",
            }}
          />
        </Tooltip>
      );
    })}
  </div>
);

interface RoleIconSelectorProps {
  value: Role;
  onToggle: (role: Role, checked: boolean) => void;
}

export const RoleIconSelector: React.FC<RoleIconSelectorProps> = ({
  value,
  onToggle,
}) => (
  <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
    {roleIconConfig.map(({ role, icon, label }) => {
      const active = Role.hasRole(value, role);
      return (
        <label
          key={role}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
            color: active ? roleIconColors.active : roleIconColors.inactive,
            fontSize: "0.75rem",
          }}
        >
          <input
            type="checkbox"
            name="role"
            value={role}
            checked={active}
            onChange={(event) => onToggle(role, event.currentTarget.checked)}
            style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
          />
          <FontAwesomeIcon
            icon={icon}
            style={{
              fontSize: "1.25rem",
              color: active ? roleIconColors.active : roleIconColors.inactive,
            }}
          />
          <span style={{ marginTop: 4 }}>{label}</span>
        </label>
      );
    })}
  </div>
);
